const ENV = process.env.ENV

// Paypal API credentials
const PAYPAL_CLIENT_ID = "AWKTh7sxVml1dsA-H4TSkD6uUc30aZU5p12QKby9DTXU1iSLEko3qH9Bk5txCgZn0ZX6pa9WSyT4oW59"
const PAYPAL_SUBSCRIPTION_PLANS = {
  HUF: {
    1000: "P-49T120793R010984LMHZGLQY",
    5000: "P-6MX80376685735350MHZGLWY",
    10000: "P-6L272455V0525522FMHZGL4Q",
    50000: "P-3MH247746X974650EMHZGMDI",
  },
  EUR: {
    10: "P-7P089410NN606501MMHZGKEQ",
    25: "P-62H5199100000350GMHZGKVY",
    50: "P-9V322165NM213743LMHZGLCA",
    100: "P-48C34746MF476910HMHZGLIQ",
  },
}

// Paypal test API credentials
/* const PAYPAL_TEST_CLIENT_ID = "Ac2fs9l6P28tjVPj1yx7SsSQRxHcSChopTme3ETMSPYpklwr6nr7oWAGsNdnrsCgXYIgOVr_vjjVFcCV"
const PAYPAL_TEST_SUBSCRIPTION_PLANS = {
  HUF: {
    1000: "P-16G31522CW081950AMHUVIVI",
    5000: "P-8TY02543KY395271JMHXFCYI",
    10000: "P-2TE57998XS758701GMHXFE3I",
    50000: "P-4CR52083R7908052AMHXFFHA",
  },
  EUR: {
    10: "P-9U242030Y81526211MHUVHNQ",
    25: "P-3VU267693H9135525MHXFF2I",
    50: "P-6SE1424392220451WMHXFGMI",
    100: "P-8CK2870121173122XMHXFGUY",
  },
} */

const LOCALES = {
  hu: "Magyar",
  en: "English",
  it: "Italiano",
}

export default {
  ENV,
  PAYPAL_CLIENT_ID,
  PAYPAL_SUBSCRIPTION_PLANS,
  LOCALES,
}
